import React, { SVGProps } from 'react'
export const SecondDefaultLeftSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="36"
    viewBox="0 0 16 36"
    fill="none"
    {...props}
  >
    <path
      fill="#7F7472"
      fillRule="evenodd"
      d="M5.876 9.032c-2.492 1.605-3.98 3.431-4.399 5.494-1.51 7.435.484 12.528 3.62 15.771C8.258 33.567 12.741 35 16 35v1c-3.486 0-8.221-1.518-11.582-4.993C1.033 27.506-1.037 22.06.536 14.319c.495-2.437 2.227-4.46 4.834-6.137C7.979 6.502 11.76 5.127 16 4v1C11.804 6.115 8.367 7.429 5.876 9.032Z"
      clipRule="evenodd"
    />
  </svg>
)
